import React, { useEffect, useState, useContext } from 'react'
import {
  CButton,
  CCol,
  CFormInput,
  CFormLabel,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
  CImage,
  CFormSelect,
} from '@coreui/react'
import { isEmpty } from '../../utils/helper'
import FBLogo from '../../../assets/social/facebook.png'
import InstaLogo from '../../../assets/social/instagram.png'
import TwitterLogo from '../../../assets/social/twitter.png'
import ImageUploader from 'src/components/ImageUploader/ImageUploader'
import { getThumbnail } from '../../utils/helper'
import CustomMetadata from 'src/components/CustomMetadata/CustomMetadata'
import { AppContext } from 'src/views/context/app'
import Loading from 'react-fullscreen-loading'
import { GlobalContext } from 'src/views/context/GlobalState'
import { CustomDescriptionBox } from '../../../components'

const ArtistCreateModal = (props) => {
  const {
    openModal,
    onCancel,
    data,
    addCallback,
    updateCallback,
    artistTypes,
    customMetadataMaster,
  } = props
  const { loader } = useContext(AppContext)
  const { userSessionObj } = useContext(GlobalContext)

  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [thumbnail, setThumbnail] = useState('')
  const [poster, setPoster] = useState('')

  const [artistType, setArtistType] = useState('')
  const [socialProfiles, setSocialProfilesn] = useState({
    facebook: '',
    twitter: '',
    instagram: '',
  })
  const [customMetadata, setCustomMetadata] = useState({})
  const [errorData, setErrorData] = useState({})
  const [imageData, setImageData] = useState()

  const editFlag = !isEmpty(data)

  useEffect(() => {
    const artistImage = [
      {
        title: 'Banner *',
        id: 'artistBanner',
        width: 1200,
        height: 675,
        divheight: '9.56rem',
        divwidth: '17rem',
        assetId: '',
        setAssetId: (id) => {
          let temp = errorData
          temp[`thumbnail`] = ''
          setErrorData({ ...temp })
          setThumbnail(id)
        },
        setImage: () => {},
        onRemoveImg: () => {},
        imageUrl: '',
      },
      {
        title: 'Poster*',
        id: 'artistPoster',
        width: 325,
        height: 416,
        assetId: '',
        divheight: '11.52rem',
        divwidth: '9rem',
        setAssetId: (id) => {
          let temp = errorData
          temp[`thumbnail`] = ''
          setErrorData({ ...temp })
          setPoster(id)
        },
        setImage: () => {},
        onRemoveImg: () => {},
        imageUrl: '',
      },
    ]
    if (!isEmpty(data)) {
      handleEdit()
      artistImage[0]['assetId'] = data.thumbnail['_id']
      artistImage[0]['imageUrl'] = getThumbnail(
        userSessionObj.session_data.cf_domain_name,
        data.thumbnail['s3_key'],
      )
      artistImage[1]['assetId'] = data.poster['_id']
      artistImage[1]['imageUrl'] = getThumbnail(
        userSessionObj.session_data.cf_domain_name,
        data.poster['s3_key'],
      )
    }
    setImageData(artistImage)
  }, [])

  const handleEdit = () => {
    setName(data.name)
    setThumbnail(data.thumbnail['_id'])
    setDescription(data.bio)
    setPoster(data.poster['_id'])
    const tempArtistType = artistTypes.find((obj) => obj.name === data.artist_type)
    if (tempArtistType) {
      setArtistType(data.artist_type)
    } else {
      setArtistType('')
    }
    setSocialProfilesn(data.social_profiles)
  }

  const handleChange = (event, func) => {
    const { value, name } = event.target
    let temp = errorData
    temp[`${name}`] = ''
    setErrorData({ ...temp })
    func(value)
  }
  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (name.trim().length === 0) {
      isFormValid = false
      temp.name = 'Name Cannot be Empty!'
    }

    if (!thumbnail) {
      isFormValid = false
      temp.thumbnail = 'UploadContent Images!'
    }

    if (!poster) {
      isFormValid = false
      temp.thumbnail = 'UploadContent Images!'
    }
    if (!artistType) {
      isFormValid = false
      temp.artistType = 'Select Artist!'
    }
    setErrorData({ ...temp })
    return isFormValid
  }

  const handleSave = () => {
    if (!validateInfo()) return
    let payload
    payload = {
      name: name,
      bio: description,
      artist_type: artistType,
      poster: poster,
      thumbnail: thumbnail,
      social_profiles: socialProfiles,
      custom_metadata: customMetadata,
    }

    editFlag ? updateCallback(payload, data._id) : addCallback(payload)
  }

  return (
    <>
      <CModal size="lg" visible={openModal} alignment="center">
        <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
        <CModalHeader className="px-5 py-4">
          <CModalTitle>
            {!editFlag ? `Add` : `Edit`} {`Artist`}
          </CModalTitle>
        </CModalHeader>
        <CModalBody className="px-5 py-4">
          <CRow>
            <CCol>
              <CFormLabel>Name*</CFormLabel>
              <CFormInput
                type="text"
                value={name}
                name="name"
                onChange={(e) => handleChange(e, setName)}
              />
              <div className="message-text error-message">
                <p>{errorData.name}</p>
              </div>
            </CCol>
            <CCol>
              <CustomDescriptionBox
                title="Bio"
                rows={1}
                value={description}
                onChange={setDescription}
              />
            </CCol>
          </CRow>
          <CRow className="mt-3">
            <CCol>
              <CFormLabel>Type*</CFormLabel>
              <CFormSelect
                value={artistType}
                name="artistType"
                onChange={(e) => handleChange(e, setArtistType)}
              >
                <option value="" disabled selected>
                  Select Option
                </option>
                {artistTypes &&
                  artistTypes.map((item, index) => (
                    <option value={item.name} key={index}>
                      {item.name}
                    </option>
                  ))}
              </CFormSelect>
              <div className="message-text error-message">
                <p>{errorData.artistType}</p>
              </div>
            </CCol>
            <CCol>
              <CFormLabel>{`Facebook profile`}</CFormLabel>
              <div className="d-flex align-items-center">
                <CCol>
                  <CImage fluid src={FBLogo} className="mx-2" width={30} height={30} />
                </CCol>
                <CCol lg="10">
                  <CFormInput
                    value={socialProfiles.facebook}
                    onChange={(e) =>
                      setSocialProfilesn({ ...socialProfiles, facebook: e.target.value })
                    }
                  />
                </CCol>
              </div>
            </CCol>
            <div className="w-100 mt-3" />
            <CCol>
              <CFormLabel>{`Instagram profile`}</CFormLabel>
              <div className="d-flex align-items-center">
                <CCol>
                  <CImage fluid src={InstaLogo} className="mx-2" width={30} height={30} />
                </CCol>
                <CCol lg="10">
                  <CFormInput
                    value={socialProfiles.instagram}
                    onChange={(e) =>
                      setSocialProfilesn({ ...socialProfiles, instagram: e.target.value })
                    }
                  />
                </CCol>
              </div>
            </CCol>
            <CCol>
              <CFormLabel>{`Twitter profile`}</CFormLabel>
              <div className="d-flex align-items-center">
                <CCol>
                  <CImage fluid src={TwitterLogo} className="mx-2" width={30} height={30} />
                </CCol>
                <CCol lg="10">
                  <CFormInput
                    value={socialProfiles.twitter}
                    onChange={(e) =>
                      setSocialProfilesn({ ...socialProfiles, twitter: e.target.value })
                    }
                  />
                </CCol>
              </div>
            </CCol>
          </CRow>
          <CRow className="mt-4">
            <CustomMetadata
              isEdit={editFlag}
              editData={data}
              customMetadataMaster={customMetadataMaster}
              customPayload={customMetadata}
              setCustomPayload={setCustomMetadata}
            />
          </CRow>
          <CRow className="mt-5">
            {imageData && <ImageUploader data={imageData} />}
            <div className="message-text error-message">
              <p>{errorData.thumbnail}</p>
            </div>
          </CRow>
        </CModalBody>
        <CModalFooter>
          <CButton className="text-white" color="info" onClick={onCancel}>
            Cancel
          </CButton>
          <CButton className="text-white" color="info" onClick={handleSave}>
            Submit
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default ArtistCreateModal
